import { useState } from 'react';

// import PropsType from 'prop-types'

// @mui
import { alpha } from '@mui/material/styles';
import { Box, Button, Divider, Typography, Stack, MenuItem, IconButton, Popover } from '@mui/material';

import { useNavigate } from 'react-router-dom';

// import { useAvatarLabel } from "../../hooks/useAvaterLabel"
import { useAuthAccess, authTargetTypes } from '../../hooks/useAuthAccess';
import { useSystemPrompt } from '../../hooks/useSystemPrompt';
import { useSystemRoutes, routeTypes } from '../../hooks/useSystemRoutes';

// import CommonAvatarIcon from '../../components/common/CommonAvaterIcon';
import { CommonIcons, icons } from '../../components/common/CommonIcons';

export default function MenuAccount({ t }) {

  const { getRoute } = useSystemRoutes(routeTypes.workstation)

  const MENU_OPTIONS = [
    // {
    //   label: 'Home',
    //   icon: 'eva:home-fill',
    // },
    {
      label: 'Update Profile',
      icon: 'eva:person-fill',
      to: getRoute(`profile`)
    },
    {
      label: 'Change Password',
      icon: 'eva:settings-2-fill',
      to: getRoute(`password`)
    },
  ];

  // const { AvatarLabel } = useAvatarLabel();
  const { authData, performLogout } = useAuthAccess(authTargetTypes.workstation);
  const { promptMessage } = useSystemPrompt();

  const navigate = useNavigate();

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const navigateTo = (to, toParams = null, onClick) => {
    if (onClick) onClick();
    if (to) {
      // console.log('toParams', toParams)

      if (toParams) {
        navigate(to, {
          state: toParams
        })
      } else {
        navigate(to)
      }

    }
  }

  const handleLogout = () => {

    performLogout();

    navigate(getRoute("login"))

    promptMessage(true, `You have logout successfully`);

    handleClose();
  }

  const RenderHeader = () => {
    return (
      <Box>
        <Typography variant="subtitle2" noWrap>
          {authData?.displayName}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
          {authData?.email}
        </Typography>

      </Box>
    )
  }

  return (
    <>
      {/* <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <CommonAvatarIcon />
      </IconButton> */}

      <Button
        // {...bindTrigger(popupState)}
        onClick={handleOpen}
        size="large"
        variant='text'
        sx={{
          // backgroundColor: '#000',
          // borderRadius: 30,
        }}
      >
        {/* <MoreVertIcon /> */}
        <CommonIcons
          name={icons.profile}
          sx={{
            color: '#000'
          }}
        />
      </Button>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 200,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <RenderHeader />
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={() => { navigateTo(option?.to) }}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          {
            t("logout")
          }
        </MenuItem>

      </Popover>
    </>
  );
}
